import React from "react";

const PageNotFound = () => <h1>404 ! Page not found.</h1>;

export default PageNotFound;
